export const TITLE = 'Hej med dig!';
export const LOG_IN = 'Log ind';
export const FORGOT_PASSWORD = 'Glemt adgangskode';
export const NEW_USER = 'Ny bruger';
export const PASSWORD = 'Adgangskode';
export const EMAIL = 'E-mail';
export const REMEMBER_ME = 'Husk mig';
export const WRONG_PASSWORD = 'Forkert adgangskode';
